import React from 'react';
import { WidgetLink } from './WidgetLink';
import { WidgetTruncatedText } from './WidgetTruncatedText';
import { useTranslation } from 'react-i18next';

export function WidgetLinkTruncatedText ({ to, text, options = {}, styles, truncated }) {
    const { t } = useTranslation();
    const formattedText = /\..*\./.test(text) ? t(text) : text;
    const emptyText = text === 'S/D';
    const formattedStyles = emptyText ? { textDecoration: 'none' } : styles;

    const renderText = () => {
        return (
            <WidgetTruncatedText text={emptyText ? '-' : formattedText} options={options} styles={formattedStyles} truncated={truncated}/>);
    };
    return (emptyText ? renderText() : <WidgetLink to={to} text={renderText()} />);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetLinkTruncatedText.displayName = 'WidgetLinkTruncatedText';
}
